import i18n from "i18next";
import { memo, type ReactNode, useMemo } from "react";
import { I18nextProvider } from "react-i18next";

export interface ScopedLocaleProviderProps {
  children: ReactNode;
  locale: string;
}

export const ScopedLocaleProvider = memo(function ScopedLocaleProvider({
  children,
  locale,
}: ScopedLocaleProviderProps) {
  const scopedI18n = useMemo(
    () =>
      i18n.cloneInstance({
        initImmediate: false,
        lng: locale,
        react: {
          ...i18n.options.react,
          bindI18nStore: "added removed",
        },
      }),
    [locale],
  );

  return <I18nextProvider i18n={scopedI18n}>{children}</I18nextProvider>;
});
